import * as React from 'react';
import * as styles from './CommercialTab.css';

interface ICommercialTabProps {
  image: React.ReactNode;
  description: React.ReactNode;
}

export function CommercialTab({ image, description }: ICommercialTabProps) {
  return (
    <div>
      {image && <div className={styles['image']}>{image}</div>}

      {description}
    </div>
  );
}
